// Minimal class joiner for the primitives: drops falsy entries so callers can
// write `cx(BASE, active && ACTIVE, className)` without producing "undefined"
// in the DOM. Deliberately not a dependency — this is the whole feature.
export const cx = (...parts) => parts.filter(Boolean).join(' ');
